<div class="card-wrapper box-shadow">
    <div class="title-container">
        <img *ngIf="data.image" class="employee-image" src="{{ data.image }}" onerror="this.src='assets/images/user2.jpg'" alt="" />
        <div class="label-name" [ngStyle]="{ 'font-size': data.titleSize, color: data.titleColor }">
            <div class="nameCard">
                <span *ngIf="type === 'employees'" class="name">{{ data.title | firstMiddleAndLastName }}</span>
                <span *ngIf="type !== 'employees'" class="name">{{ data.title | translate }}</span>
            </div>
            <span
                *ngIf="type === 'employees' && loggedInUserService.isAccountManager()"
                [ngClass]="{
                    activate: data.status !== 'DEACTIVATED',
                    deactivate: data.status === 'DEACTIVATED'
                }"
                class="status"
                >{{ data.status | handleCardItemsListStatusDashboard }}</span
            >
        </div>
    </div>

    <div class="d-flex justify-content-between">
        <div class="requests-status-count-container" *ngFor="let item of data.requestsStatusData">
            <p class="name">{{ item.text }}</p>
            <p class="count" [ngStyle]="{ color: item.textHexColor }">
                {{ item.totalCount }}
            </p>
        </div>
    </div>
</div>
